import React from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'

const AutoDeliver = ({ order, readOnly }) => {
  const { formatMessage } = useIntl()
  
  const onClick = () => {
    if(confirm(formatMessage(messages.confirm))) {
      fetch(`/notification/setAutoDeliveryOrder.html?orderId=${order.uid}`, { 
        method: 'POST'
      }) 
      .then((response) => response.text())
      .then((response) => {
        return response == 'ok'
      })
      .then(() => {
        fetch(`/ordertask/setAllowAutoDeliveryForOrder.html?orderId=${order.uid}`, { 
          method: 'POST'
        }) 
        .then((response) => response.text())
        .then((response) => {
          if (response == 'OK') {
            toastr.success(formatMessage(messages.success))
          } else {
            toastr.error(formatMessage(messages.error))
          }
        })
        .catch((error) => toastr.error(error))
      })
      .catch((error) => toastr.error(error))
    }
  }

  return (
    <Menu.Item key='autoDeliver' disabled={readOnly}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={onClick}>
          { formatMessage(messages.title) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default AutoDeliver
